import { UserMetaData } from "@/types/user";
import { Auth0CustomUserProfile } from "./auth0";
import { ALLOW_PROFILE_IMAGE_UPLOAD } from "@/constants/user";
import env from "@/env";
import localCookies from "./cookie";
import { v4 } from "uuid";
import { getAuthContext } from "@/store/machine/authMachine/authMachine";
import { GUEST_USER_ID_HEADER, GUEST_USER_MIGRATION_HEADER } from "./api";

const INVALID_TIMEZONES = ["Asia/Beijing"];

export const getUserPicture = (profile?: Auth0CustomUserProfile<UserMetaData>) => {
  if (!ALLOW_PROFILE_IMAGE_UPLOAD) {
    return DEFAULT_PROFILE_IMAGE;
  }
  return profile?.user_metadata.picture || DEFAULT_PROFILE_IMAGE;
};

const DEFAULT_PROFILE_IMAGE = "/assets/images/placeholder.jpg";

export const toStringWithLoginVersionSuffix = (key: string) => {
  if (!env.LOGIN_VERSION) {
    return key;
  }
  return `${key}_${env.LOGIN_VERSION.split(".").join("_")}`;
};

export const getUserTimezone = (profile?: Auth0CustomUserProfile<UserMetaData>) => {
  const timeZone = profile?.user_metadata.timezone;
  return !timeZone || INVALID_TIMEZONES.includes(timeZone)
    ? "UTC"
    : profile?.user_metadata.timezone;
};

export const errorIndicatesRequiresLogin = (e: unknown) => {
  return ["token is missing", "network problem"].includes((e as Error).message.toLowerCase());
};

const GUEST_USER_ID_COOKIE = "guest_user_id";

export const getGuestUserId = () => {
  const { userId, isLoggedIn } = getAuthContext();
  if (userId) {
    return undefined;
  }
  if (isLoggedIn) {
    return undefined;
  }
  let guestUserId = localCookies.getItem(GUEST_USER_ID_COOKIE);
  if (!guestUserId) {
    guestUserId = v4();
    localCookies.setItem(GUEST_USER_ID_COOKIE, guestUserId);
  }
  return guestUserId;
};

export const getGuestUserHeaders = () => {
  const { userId, isLoggedIn } = getAuthContext();
  const guestUserId = localCookies.getItem(GUEST_USER_ID_COOKIE);
  if (isLoggedIn || userId) {
    if (guestUserId) {
      clearGuestUserId();
    }
    return {
      [GUEST_USER_MIGRATION_HEADER]: guestUserId
    };
  }
  return {
    [GUEST_USER_ID_HEADER]: guestUserId
  };
};

export const clearGuestUserId = () => {
  localCookies.removeItem(GUEST_USER_ID_COOKIE);
};
